import axios from "axios";

const api = axios.create({
  //baseURL: "http://192.168.1.100:3001",
  baseURL: "https://apibpc.softwareplus.com.br/api",
  auth: {
    username: process.env.REACT_APP_USUARIO,
    password: process.env.REACT_APP_SENHA,
  },
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "Authorization",
    "Access-Control-Allow-Methods": "GET, POST, OPTIONS, PUT, PATCH, DELETE",
    "Content-Type": "application/json;charset=UTF-8",
    Accept: "*/*",
  },
});

export default api;
